import Vue from 'vue';

export default Vue.extend({
  props: ['multiProgress', 'confirmProgress', 'actionProgress'],
  data() {
    return {
      progressIndex: 0,
    };
  },
  computed: {
    currentProgress() {
      return this.multiProgress[this.progressIndex];
    },
    currentDevice() {
      return this.$store.state.device.currentDevice;
    },
    currentDrugInDevice() {
      return this.$store.state.drugInDevice.currentDrugInDevice;
    },
    currentDrug() {
      return this.$store.getters.currentDrug;
    },
    currentSchedule() {
      return this.$store.getters.currentSchedule;
    },
    instance() {
      return this.$store.state.instance;
    },
    nextDevice() {
      return this.$store.state.device.nextDevice;
    },
    nextDrugInDevice() {
      return this.$store.state.drugInDevice.nextDrugInDevice;
    },
    nextEvent() {
      return this.$store.state.event.nextEvent;
    },
    nextDrug() {
      return this.$store.getters.nextDrug;
    },
    selectedDrugTotalAmount() {
      return this.$store.state.drug.selectedDrugTotalAmount;
    },
    errorDevices() {
      return this.$store.state.device.errorDevices;
    },
  },
  methods: {
    nextProgress() {
      this.progressIndex += 1;
    },
    resetProgress() {
      this.progressIndex = 0;
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/ComponentBase/MultiFlowBase.js